"use strict";
export default React.createClass({
  render: function() {
    if (this.props.source) {
      var source = this.props.source;
      var prefix = this.props.prefix || "";
      var line2 = source[prefix + "address_line_2"];
      var country = source[prefix + "country"];
      const city = source[prefix + "city"];
      const state = source[prefix + "state"];
      const postalCode = source[prefix + "postal_code"];
      if (country === "US" || country === "USA" || country === "United States") {
        country = null;
      }
      const line1Divider = this.props.compact ? " - " : /* @__PURE__ */ React.createElement("br", null);
      return /* @__PURE__ */ React.createElement("div", null, source[prefix + "name"], " ", /* @__PURE__ */ React.createElement("br", null), source[prefix + "address_line_1"], line1Divider, line2, " ", !_.isEmpty(line2) ? /* @__PURE__ */ React.createElement("br", null) : "", /* @__PURE__ */ React.createElement("span", null, " ", this.cityStateZip(city, state, postalCode), " "), !_.isEmpty(country) ? /* @__PURE__ */ React.createElement("br", null) : "", " ", country);
    } else {
      return /* @__PURE__ */ React.createElement("div", null, this.props.children);
    }
  },
  possibleCityState: function(city, state) {
    return _.compact([city, state]).join(" ");
  },
  cityStateZip: function(city, state, postalCode) {
    return _.compact([this.possibleCityState(city, state), postalCode]).join(", ");
  },
  possibleComma: function(city, state) {
    if (!_.isEmpty(city) || !_.isEmpty(state)) {
      return ",";
    } else {
      return "";
    }
  }
});
